import React, { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { ausgabenApi } from '../api';

const KATEGORIEN = ['Hardware (PC, Monitore...)', 'Software / Lizenzen', 'Bücher / Fachliteratur', 'Büromaterial', 'Sonstiges'];

export default function AusgabeFormPage() {
  const navigate = useNavigate();
  const { id } = useParams();
  const isEdit = !!id;
  const aktuellesJahr = new Date().getFullYear();

  const [form, setForm] = useState({
    bezeichnung: '', kategorie: 'Hardware (PC, Monitore...)', betrag: '',
    kaufdatum: new Date().toISOString().split('T')[0],
    steuerjahr: aktuellesJahr, steuerrelevant: false, notizen: ''
  });
  const [beleg, setBeleg] = useState(null);
  const [vorhandenerBeleg, setVorhandenerBeleg] = useState(null);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  useEffect(() => { if (isEdit) laden(); }, [id]);

  async function laden() {
    try {
      const res = await ausgabenApi.get(id);
      const d = res.data;
      setForm({
        bezeichnung: d.bezeichnung || '', kategorie: d.kategorie || KATEGORIEN[0],
        betrag: d.betrag || '', kaufdatum: d.kaufdatum || '',
        steuerjahr: d.steuerjahr || aktuellesJahr,
        steuerrelevant: d.steuerrelevant === 1, notizen: d.notizen || ''
      });
      if (d.beleg_dateiname) setVorhandenerBeleg(d.beleg_originaldateiname);
    } catch (e) { setError('Fehler beim Laden'); }
  }

  async function speichern(e) {
    e.preventDefault();
    setLoading(true);
    setError('');
    try {
      const formData = new FormData();
      Object.entries(form).forEach(([k, v]) => formData.append(k, v));
      if (beleg) formData.append('beleg', beleg);
      if (isEdit) await ausgabenApi.update(id, formData);
      else await ausgabenApi.create(formData);
      navigate('/ausgaben');
    } catch (e) { setError(e.response?.data?.error || 'Fehler beim Speichern'); }
    setLoading(false);
  }

  const inp = { width: '100%', padding: '8px 12px', borderRadius: '6px', border: '1px solid #334155', color: '#f1f5f9', background: '#0f172a', fontSize: '14px', boxSizing: 'border-box' };
  const lbl = { display: 'block', marginBottom: '6px', fontWeight: '600', color: '#94a3b8', fontSize: '12px' };

  return (
    <div style={{ padding: '24px', maxWidth: '600px', margin: '0 auto' }}>
      <div style={{ display: 'flex', alignItems: 'center', gap: '12px', marginBottom: '24px' }}>
        <button onClick={() => navigate('/ausgaben')} style={{ background: 'none', border: 'none', fontSize: '20px', cursor: 'pointer', color: '#818cf8' }}>←</button>
        <h2 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#f1f5f9' }}>{isEdit ? '✏️ Ausgabe bearbeiten' : '➕ Neue Ausgabe'}</h2>
      </div>

      {error && <div style={{ background: '#431407', color: '#fca5a5', border: '1px solid #ef4444', padding: '12px', borderRadius: '8px', marginBottom: '16px' }}>{error}</div>}

      <form onSubmit={speichern} style={{ display: 'flex', flexDirection: 'column', gap: '20px' }}>
        <div>
          <label style={lbl}>Bezeichnung *</label>
          <input style={inp} value={form.bezeichnung} onChange={e => setForm({...form, bezeichnung: e.target.value})} placeholder="z.B. MacBook Pro M3" required />
        </div>
        <div>
          <label style={lbl}>Kategorie *</label>
          <select style={inp} value={form.kategorie} onChange={e => setForm({...form, kategorie: e.target.value})}>
            {KATEGORIEN.map(k => <option key={k} value={k}>{k}</option>)}
          </select>
        </div>
        <div style={{ display: 'grid', gridTemplateColumns: 'repeat(auto-fit, minmax(150px, 1fr))', gap: '16px' }}>
          <div>
            <label style={lbl}>Betrag (€) *</label>
            <input style={inp} type="number" step="0.01" min="0" value={form.betrag} onChange={e => setForm({...form, betrag: e.target.value})} placeholder="0.00" required />
          </div>
          <div>
            <label style={lbl}>Kaufdatum *</label>
            <input style={inp} type="date" value={form.kaufdatum} onChange={e => setForm({...form, kaufdatum: e.target.value})} required />
          </div>
        </div>
        <div>
          <label style={lbl}>Steuerjahr *</label>
          <select style={inp} value={form.steuerjahr} onChange={e => setForm({...form, steuerjahr: parseInt(e.target.value)})}>
            {Array.from({ length: 6 }, (_, i) => aktuellesJahr - i).map(j => <option key={j} value={j}>{j}</option>)}
          </select>
        </div>
        <div style={{ background: form.steuerrelevant ? '#052e16' : '#1e293b', borderRadius: '10px', padding: '16px', border: `2px solid ${form.steuerrelevant ? '#22c55e' : '#334155'}`, cursor: 'pointer' }}
          onClick={() => setForm({...form, steuerrelevant: !form.steuerrelevant})}>
          <div style={{ display: 'flex', alignItems: 'center', gap: '12px' }}>
            <div style={{ width: '24px', height: '24px', borderRadius: '6px', background: form.steuerrelevant ? '#22c55e' : '#334155', display: 'flex', alignItems: 'center', justifyContent: 'center', color: 'white', fontWeight: '700' }}>
              {form.steuerrelevant ? '✓' : ''}
            </div>
            <div>
              <div style={{ fontWeight: '600', color: '#f1f5f9' }}>Steuerrelevant</div>
              <div style={{ fontSize: '13px', color: '#94a3b8' }}>Diese Ausgabe kann steuerlich geltend gemacht werden</div>
            </div>
          </div>
        </div>
        <div>
          <label style={lbl}>Beleg hochladen</label>
          {vorhandenerBeleg && !beleg && (
            <div style={{ marginBottom: '8px', padding: '8px 12px', background: '#052e16', borderRadius: '6px', fontSize: '13px', color: '#86efac' }}>
              📎 Aktuell: {vorhandenerBeleg}
            </div>
          )}
          <input type="file" accept="image/*,.pdf" onChange={e => setBeleg(e.target.files[0])} style={{ ...inp, padding: '8px' }} />
          <div style={{ fontSize: '12px', color: '#94a3b8', marginTop: '4px' }}>JPG, PNG, WebP oder PDF · max. 20 MB</div>
        </div>
        <div>
          <label style={lbl}>Notizen</label>
          <textarea style={{ ...inp, minHeight: '80px', resize: 'vertical' }} value={form.notizen} onChange={e => setForm({...form, notizen: e.target.value})} placeholder="Optionale Notizen..." />
        </div>
        <div style={{ display: 'flex', gap: '12px', paddingTop: '8px' }}>
          <button type="button" onClick={() => navigate('/ausgaben')}
            style={{ flex: 1, padding: '12px', background: '#334155', color: '#94a3b8', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', minHeight: 44 }}>Abbrechen</button>
          <button type="submit" disabled={loading}
            style={{ flex: 2, padding: '12px', background: '#818cf8', color: 'white', border: 'none', borderRadius: '6px', cursor: 'pointer', fontWeight: '600', opacity: loading ? 0.5 : 1, minHeight: 44 }}>
            {loading ? 'Speichern...' : (isEdit ? '💾 Speichern' : '➕ Ausgabe hinzufügen')}
          </button>
        </div>
      </form>
    </div>
  );
}
